import { downloadSourceFile } from "../../../../actions/CarrierAgreementMgmt/Carrier";
import { toast } from "../../../../components/toastNotification";
import DownloadButton from "../../../../components/DownloadButton";
import Table from "../../../../components/tables/Table";

const SourceLinkTable = ({ data }) => {
  const downloadFile = (fileName) => {
    try {
      downloadSourceFile(fileName).then((content) => {
        if (content.status === 200) {
          var url = window.URL.createObjectURL(content.data);
          let tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
          toast.fire("Success", "File downloaded successfully", "success");
        }
        if (content.status === 404) {
          toast.fire(
            "Error downloading file:",
            "The file has not been found in the system.",
            "error"
          );
        }
      });
    } catch (error) {
      toast.fire(
        "Failed to download file",
        "Server Error: Cannot download file due to: " + error,
        "error"
      );
    }
  };

  const columns = [
    {
      name: "Link ",
      cell: (row) => row.sourceFile,
      center: true,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <DownloadButton
          buttonValue="Download"
          className="m-3 w-28"
          onClick={() => downloadFile(row.sourceFile)}
        />
      ),
      sortable: true,
      center: true,
    },
  ];

  return (
    <div className="space-y-2 mt-5">
      <Table
        columns={columns}
        data={data}
        loading={false}
        selectableRows={false}
        expandableRowsComponent={undefined}
        expandableRowExpanded={undefined}
        onSelectedRowsChange={undefined}
        clearSelectedRows={undefined}
        setOpenModal={undefined}
      />
    </div>
  );
};
export default SourceLinkTable;
